export default __webpack_public_path__ + "static/media/excel_preview.4bab4439.svg";